import { FIELD_TYPE } from '../constants/Constants';
import { IAddressAttributes } from '../domain/entities/Address/Address';
import { isKorea } from './CountryUtils';

const KOREAN_ADDRESS_ALLOWED_CHARACTERS = /^[\p{Script=Hangul}\d\p{P}\p{S}\s]+$/u;

export const SHIPPING_ADDRESS_WARNING_FIELDS = [
  FIELD_TYPE.FIRST_LINE_ADDRESS,
  FIELD_TYPE.SECOND_LINE_ADDRESS,
  FIELD_TYPE.THIRD_LINE_ADDRESS,
] as const;

export const showNonKoreanShippingWarning = (
  attributes?: IAddressAttributes,
  countryId: number | null = null,
): boolean => {
  if (!attributes || typeof countryId !== 'number' || !isKorea(countryId)) {
    return false;
  }

  return SHIPPING_ADDRESS_WARNING_FIELDS.some(field => {
    const fieldValue = attributes[field]?.trim();
    if (!fieldValue) return false;
    return Array.from(fieldValue).some(
      character => !KOREAN_ADDRESS_ALLOWED_CHARACTERS.test(character),
    );
  });
};
